import React from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import InstitutionProfile from "../../../components/common/InstitutionProfile"
import "../../../components/common/bt.css";
const fmt = (val) => Number(val || 0).toFixed(2);

const AccountBalanceTable = ({ printMode = false, filters = {} }) => {
  const { list, loading, totals } = useSelector(
    (state) => state.accountBalance
  );

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Account Name", dataIndex: "acc_name" },
    {
      title: "Acc. Type",
      dataIndex: "acc_type_id",
      render: (val) => val?.replaceAll("_", " ").toUpperCase(),
    },
    {
      title: "Opening Balance",
      dataIndex: "opening_balance",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
    {
      title: "Debit Amount - (IN)",
      dataIndex: "received_total",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
    {
      title: "Credit Amount - (OUT)",
      dataIndex: "payment_total",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: (val) => <strong style={{ color: "green" }}>{Number(val).toFixed(2)}</strong>,
    },
  ];

  if (printMode) {
    return (
      <table className="ledger-print-table">
        <colgroup>
          <col style={{ width: "5%" }} />
          <col style={{ width: "27%" }} />
          <col style={{ width: "16%" }} />
          <col style={{ width: "15%" }} />
          <col style={{ width: "13%" }} />
          <col style={{ width: "13%" }} />
          <col style={{ width: "11%" }} />
        </colgroup>
        <tbody>
          <tr className="ledger-print-heading">
            <td>No.</td>
            <td>Account Name</td>
            <td>Acc. Type</td>
            <td style={{ textAlign: "right" }}>Opening Balance</td>
            <td style={{ textAlign: "right" }}>Debit Amount</td>
            <td style={{ textAlign: "right" }}>Credit Amount</td>
            <td style={{ textAlign: "right" }}>Balance</td>
          </tr>

          {list.map((row, index) => (
            <tr key={row.acc_id || index}>
              <td>{index + 1}</td>
              <td>{row.acc_name}</td>
              <td>{row.acc_type_id?.replaceAll("_", " ").toUpperCase()}</td>
              <td style={{ textAlign: "right" }}>{fmt(row.opening_balance)}</td>
              <td style={{ textAlign: "right" }}>{fmt(row.received_total)}</td>
              <td style={{ textAlign: "right" }}>{fmt(row.payment_total)}</td>
              <td style={{ textAlign: "right" }}>{fmt(row.balance)}</td>
            </tr>
          ))}

          <tr className="ledger-total-row">
            <td colSpan={3} style={{ textAlign: "right" }}>Grand Total</td>
            <td style={{ textAlign: "right" }}>{fmt(totals?.opening)}</td>
            <td style={{ textAlign: "right" }}>{fmt(totals?.debit)}</td>
            <td style={{ textAlign: "right" }}>{fmt(totals?.credit)}</td>
            <td style={{ textAlign: "right" }}>{fmt(totals?.balance)}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <Table
      rowKey="acc_id"
      columns={columns}
      dataSource={list}
      loading={loading}
      pagination={printMode ? false : { pageSize: 10 }}
      bordered
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={3}>
            <strong>Grand Total</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {totals.opening.toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {totals.debit.toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {totals.credit.toFixed(2)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            <strong style={{ color: "green" }}>
              {totals.balance.toFixed(2)}
            </strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default AccountBalanceTable;
